import { z } from 'zod'

export const trainerCertificateSmokeExceptionResponseSchema = z.record(z.unknown())
export type TrainerCertificateSmokeExceptionResponse = z.infer<typeof trainerCertificateSmokeExceptionResponseSchema>
